/**
 * Process Control System — static configuration.
 *
 * Drives the Process Control System landing grid and its parameterized tool
 * sub-pages. `FACTORIES` populates the 2×2 card grid; each card exposes the
 * same set of `TOOLS`. Routes are built as
 * `/portal/supplier-process-control/system/{factory.slug}/{tool.slug}`, and the
 * `findFactory` / `findTool` helpers resolve a URL slug back to its display
 * label (used by the sub-page breadcrumb).
 */

/** A selectable entry rendered in the UI and addressed by URL slug. */
export interface PcsOption {
  /** URL-safe identifier used in the route path. */
  slug: string;
  /** Human-readable label shown in the UI. */
  label: string;
}

/**
 * Manufacturing sites shown as cards on the Process Control System home.
 * NOTE: these are placeholder factory codes — adjust the labels/slugs to match
 * the real site list when it is finalized.
 */
export const FACTORIES: PcsOption[] = [
  { slug: 'cmt', label: 'CMT' },
  { slug: 'green', label: 'Green' },
  { slug: 'tonly', label: 'Tonly' },
  { slug: 'everwin', label: 'Everwin' },
];

/** Process-control tools available for every factory. */
export const TOOLS: PcsOption[] = [
  { slug: 'real-time-monitoring', label: 'Real Time Process Monitoring' },
  { slug: 'spc', label: 'SPC' },
  { slug: 'black-box-forecast', label: 'Black Box Forecast' },
];

/** Resolve a factory by its URL slug, or `undefined` if unknown. */
export function findFactory(slug: string | undefined): PcsOption | undefined {
  return FACTORIES.find((f) => f.slug === slug);
}

/** Resolve a tool by its URL slug, or `undefined` if unknown. */
export function findTool(slug: string | undefined): PcsOption | undefined {
  return TOOLS.find((t) => t.slug === slug);
}
